import { render } from "./UpdateInfos.vue?vue&type=template&id=159fed66&scoped=true"
import script from "./UpdateInfos.vue?vue&type=script&lang=js"
export * from "./UpdateInfos.vue?vue&type=script&lang=js"

import "./UpdateInfos.vue?vue&type=style&index=0&id=159fed66&lang=scss&scoped=true"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-159fed66"]])

export default __exports__